import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuBar from "../MenuBar";
import { apiFetch } from "../api";

import { useI18n } from "../i18n/I18nContext";

/* ============================================================ THÈMES */
const ACCENT = "#E6FF3E";
const THEMES = {
  dark: {
    bgPage:"#0d0f12",bgPanel:"#1a1d23",borderPanel:"#2e3240",bgCard:"#1f2330",
    borderCard:"#2e3240",bgHeader:"#252a35",textHeader:"#e8eaed",bgLabel:"#252a35",
    borderLabel:"#2e3240",textLabel:"#c8cdd8",bgInput:"#1a1d23",borderInput:"#3a3f50",
    textInput:"#e8eaed",bgForm:"#1a1d23",panelTitle:"#e8eaed",bgModal:"#1f2330",
    borderModal:"#2e3240",textModal:"#e8eaed",btnSaveBg:"#ffffff",btnSaveColor:"#000000",
    btnUpdateBg:"transparent",btnUpdateColor:"#e8eaed",btnUpdateBorder:"#3a3f50",
    shadow:"0 2px 16px rgba(0,0,0,0.5)",shadowModal:"0 10px 40px rgba(0,0,0,0.7)",
  },
  light: {
    bgPage:"#f0f2f5",bgPanel:"#e2e5ea",borderPanel:"#c9cbd1",bgCard:"#ffffff",
    borderCard:"#d0d2d8",bgHeader:"#d8d9db",textHeader:"#111111",bgLabel:"#e8eaed",
    borderLabel:"#d0d0d0",textLabel:"#1a1a1a",bgInput:"#f9fafb",borderInput:"#c0c0c0",
    textInput:"#111111",bgForm:"#ffffff",panelTitle:"#1a1a1a",bgModal:"#ffffff",
    borderModal:"#d0d2d8",textModal:"#111111",btnSaveBg:"#111111",btnSaveColor:"#ffffff",
    btnUpdateBg:"transparent",btnUpdateColor:"#111111",btnUpdateBorder:"#c0c0c0",
    shadow:"0 2px 12px rgba(0,0,0,0.08)",shadowModal:"0 10px 40px rgba(0,0,0,0.15)",
  },
};
const makeStyles = (t) => ({
  page:{minHeight:"100vh",background:t.bgPage,color:t.textInput,fontFamily:'system-ui,-apple-system,"Segoe UI",Roboto,Helvetica,Arial,sans-serif',transition:"background 0.25s,color 0.25s"},
  themeToggle:{display:"flex",justifyContent:"flex-end",padding:"10px 16px 0"},
  themeBtn:{background:t.bgHeader,color:t.textHeader,border:`1px solid ${t.borderCard}`,borderRadius:20,padding:"6px 14px",fontSize:12,fontWeight:700,cursor:"pointer",letterSpacing:"0.5px"},
  wrap:{padding:"0 16px 36px"},
  panel:{background:t.bgPanel,border:`1px solid ${t.borderPanel}`,padding:16,marginTop:14,borderRadius:8,boxShadow:t.shadow},
  panelTitle:{color:t.panelTitle,fontWeight:800,textTransform:"uppercase",letterSpacing:0.8,marginBottom:12,fontSize:15},
  card:{background:t.bgCard,border:`1px solid ${t.borderCard}`,borderRadius:8,overflow:"hidden",boxShadow:t.shadow},
  tableHeader:{background:t.bgHeader,color:t.textHeader,fontWeight:800,textTransform:"uppercase",letterSpacing:0.6,padding:"10px 16px",borderBottom:`1px solid ${t.borderCard}`,fontSize:13},
  formAndActions:{display:"grid",gridTemplateColumns:"1fr",gap:16,padding:16},
  form:{background:t.bgForm,border:`1px solid ${t.borderCard}`,borderRadius:6,overflow:"hidden"},
  row:{display:"grid",gridTemplateColumns:"1fr",borderBottom:`1px solid ${t.borderLabel}`},
  cellLabel:{background:t.bgLabel,color:t.textLabel,fontWeight:700,padding:"10px 12px",fontSize:12,letterSpacing:"0.4px",textTransform:"uppercase",borderBottom:`1px solid ${t.borderLabel}`},
  cellInput:{background:t.bgInput,padding:"8px 10px"},
  input:{width:"100%",height:36,borderRadius:4,border:`1px solid ${t.borderInput}`,padding:"0 10px",fontSize:14,background:t.bgInput,color:t.textInput,boxSizing:"border-box",outline:"none",transition:"border-color 0.2s"},
  actions:{display:"flex",flexDirection:"column",gap:10,alignItems:"stretch"},
  btnBase:{height:44,border:"none",fontWeight:800,textTransform:"uppercase",letterSpacing:0.6,cursor:"pointer",borderRadius:6,fontSize:13,transition:"opacity 0.2s,transform 0.1s"},
  btnSave:{background:t.btnSaveBg,color:t.btnSaveColor},
  btnPrint:{background:ACCENT,color:"#000"},
  btnUpdate:{background:t.btnUpdateBg,color:t.btnUpdateColor,border:`1.5px solid ${t.btnUpdateBorder}`},
  message:{marginTop:8,fontWeight:700,textAlign:"center",fontSize:13,whiteSpace:"pre-line",padding:8,borderRadius:4},
  backdrop:{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:50,padding:20,backdropFilter:"blur(3px)"},
  modal:{width:"100%",maxWidth:360,background:t.bgModal,color:t.textModal,border:`1px solid ${t.borderModal}`,borderRadius:10,boxShadow:t.shadowModal},
  modalTitle:{fontWeight:800,padding:"14px 16px",borderBottom:`1px solid ${t.borderModal}`,fontSize:14},
  modalBody:{padding:16,display:"flex",flexDirection:"column",gap:10},
  modalActions:{display:"flex",justifyContent:"flex-end",gap:10,padding:"12px 16px",borderTop:`1px solid ${t.borderModal}`},
  btnMenu:{background:ACCENT,color:"#000",border:"none",padding:"12px 16px",fontWeight:800,cursor:"pointer",borderRadius:6,fontSize:14,width:"100%"},
  btnCancel:{background:t.btnSaveBg,color:t.btnSaveColor,border:"none",padding:"10px 16px",cursor:"pointer",borderRadius:6,fontWeight:700,fontSize:13},
});

if (!document.getElementById("wf-responsive")) {
  const s = document.createElement("style");
  s.id = "wf-responsive";
  s.innerHTML = `
    @media (min-width: 640px) {
      .wf-wrap  { padding: 0 24px 36px !important; }
      .wf-row   { grid-template-columns: 200px 1fr !important; }
      .wf-label { border-bottom: none !important; border-right: 1px solid #d0d0d0 !important; }
    }
    @media (min-width: 900px) {
      .wf-wrap { padding: 0 40px 40px !important; }
      .wf-fna  { grid-template-columns: 2fr 1fr !important; gap: 20px !important; }
    }
    @media (min-width: 1024px) { .wf-wrap { padding: 0 80px 40px !important; } }
    @media (min-width: 1280px) { .wf-wrap { padding: 0 120px 40px !important; } }
    @media (min-width: 1536px) { .wf-wrap { padding: 0 200px 40px !important; } }
    @media (max-width: 639px) {
      .wf-btn   { height: 48px !important; font-size: 13px !important; }
      .wf-input { height: 40px !important; font-size: 15px !important; }
    }
    .wf-btn:hover:not(:disabled)  { opacity:0.82; transform:translateY(-1px); }
    .wf-btn:active:not(:disabled) { transform:translateY(0); }
    .wf-btn:disabled  { opacity:0.45; cursor:not-allowed; }
    .wf-input:focus   { border-color:#E6FF3E !important; box-shadow:0 0 0 3px rgba(230,255,62,0.2); }
    .wf-row:last-child { border-bottom:none !important; }
  `;
  document.head.appendChild(s);
}

/* ============================================================ COMPOSANT */
export default function ColleForm() {
  const { t, ui } = useI18n();

  const [theme, setTheme] = useState(() => localStorage.getItem("woodoo-theme") || "dark");
  const s = makeStyles(THEMES[theme]);
  const toggleTheme = () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next); localStorage.setItem("woodoo-theme", next);
  };

  const [options, setOptions]       = useState({ fournisseurs: [], couleurs: [] });
  const location                    = useLocation();
  const navigate                    = useNavigate();
  const today                       = new Date().toISOString().split("T")[0];

  const initialFormData = {
    Nature:"", Fournisseur:"", Couleur:"",
    DateReception:today, DatePeremption:"",
    QuantiteTot:"", NombreLot:"", Quantite:"",
    Temperature:"", Viscosite:"", SolidContent:"",
    PrixMetreCube:"", PN:"",
  };

  const [formData, setFormData]     = useState(initialFormData);
  const [editing, setEditing]       = useState(false);
  const [message, setMessage]       = useState("");
  const [messageColor, setMsgColor] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [printing, setPrinting]     = useState(false);
  const [updateOpen, setUpdateOpen] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiFetch("/api/options");
        if (!res.ok) throw new Error();
        const json = await res.json();
        setOptions({ fournisseurs: json.fournisseurs || [], couleurs: json.couleurs || json.coloris || [] });
      } catch {
        setMessage("❌ Impossible de charger les listes d'options."); setMsgColor("#f87171");
      }
    })();
  }, []);

  useEffect(() => {
    if (!formData.DateReception) return;
    const d = new Date(formData.DateReception);
    if (isNaN(d)) return;
    d.setMonth(d.getMonth() + 6);
    const iso = d.toISOString().split("T")[0];
    if (iso !== formData.DatePeremption) setFormData(p => ({ ...p, DatePeremption: iso }));
  }, [formData.DateReception]);

  useEffect(() => {
    const item = location.state?.item;
    if (item) { setFormData(p => ({ ...p, ...item })); setEditing(true); }
  }, [location.state]);

  const handleChange = e => setFormData(p => ({ ...p, [e.target.name]: e.target.value }));

  const toYYMM = (val) => {
    if (!val) return "";
    const m = String(val).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
    return m ? m[1].slice(-2) + m[2] : String(val);
  };

  const handleSubmit = async (e) => {
    e?.preventDefault(); setSubmitting(true); setMessage("");
    try {
      const r = await apiFetch(editing ? "/api/colle/update" : "/api/colle/add", {
        method: editing ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      const res = await r.json().catch(() => ({}));
      setMessage(res.message || "Terminé");
      setMsgColor(res.status === "success" ? "#4ade80" : "#f87171");
    } catch { setMessage("Erreur réseau"); setMsgColor("#f87171"); }
    finally { setSubmitting(false); }
  };

  const confirmPrint = async () => {
    const pn = [formData.Nature, toYYMM(formData.DateReception), formData.Fournisseur, formData.NombreLot]
      .filter(Boolean).join("_").toUpperCase();
    try {
      setPrinting(true);
      const res = await apiFetch("/api/colle/labels/a4", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ pn, n: 2 }),
      });
      if (!res.ok) throw new Error("Erreur d'impression");
      window.open(URL.createObjectURL(await res.blob()), "_blank");
      setMessage("✅ Document prêt à l'impression"); setMsgColor("#4ade80");
    } catch (e) { setMessage(e.message || "Erreur"); setMsgColor("#f87171"); }
    finally { setPrinting(false); }
  };

  const textFields = [
    { name:"QuantiteTot",  label:ui("QUANTITÉ TOTALE") },
    { name:"NombreLot",    label:"NOMBRE DE LOTS" },
    { name:"Quantite",     label:"QUANTITÉ" },
    { name:"Temperature",  label:"TEMPÉRATURE" },
    { name:"Viscosite",    label:"VISCOSITÉ" },
    { name:"SolidContent", label:ui("SOLID CONTENT") },
  ];

  return (
    <div style={s.page}>
      <MenuBar active="logistique" />

      <div style={s.themeToggle}>
        <button style={s.themeBtn} onClick={toggleTheme}>
          {theme === "dark" ? "☀️ Mode clair" : "🌙 Mode sombre"}
        </button>
      </div>

      <div style={s.wrap} className="wf-wrap">
        <section style={s.panel}>
          <div style={s.panelTitle}>SUIVI DE COLLE</div>
          <div style={s.card}>
            <div style={s.tableHeader}>PARAMÈTRES</div>

            <div style={s.formAndActions} className="wf-fna">
              <form onSubmit={handleSubmit} style={s.form}>

                <Row s={s} label="NATURE / FORMULE">
                  <input name="Nature" value={formData.Nature}
                    onChange={handleChange} style={s.input} className="wf-input" />
                </Row>

                <Row s={s} label="FOURNISSEUR">
                  <select name="Fournisseur" value={formData.Fournisseur}
                    onChange={handleChange} style={s.input} className="wf-input">
                    <option value="">-- Sélectionner --</option>
                    {options.fournisseurs.map((o, i) => (
                      <option key={i} value={o.code || o.Nom}>{o.nom || o.Nom}</option>
                    ))}
                  </select>
                </Row>

                <Row s={s} label="COULEUR">
                  <select name="Couleur" value={formData.Couleur}
                    onChange={handleChange} style={s.input} className="wf-input">
                    <option value="">-- Sélectionner --</option>
                    {options.couleurs.map((o, i) => (
                      <option key={i} value={o.code || o.Nom}>{o.nom || o.Nom}</option>
                    ))}
                  </select>
                </Row>

                <Row s={s} label="DATE DE RÉCEPTION">
                  <input type="date" name="DateReception" value={formData.DateReception}
                    onChange={handleChange} style={s.input} className="wf-input" />
                </Row>

                <Row s={s} label="DATE DE PÉREMPTION (auto +6 mois)">
                  <input type="date" name="DatePeremption" value={formData.DatePeremption}
                    onChange={handleChange} style={s.input} className="wf-input" />
                </Row>

                {textFields.map(({ name, label }) => (
                  <Row key={name} s={s} label={label}>
                    <input name={name} value={formData[name]}
                      onChange={handleChange} style={s.input} className="wf-input" />
                  </Row>
                ))}

                <Row s={s} label="PRIX / m³ (€)">
                  <input type="number" step="0.01" name="PrixMetreCube"
                    value={formData.PrixMetreCube} onChange={handleChange}
                    style={s.input} className="wf-input" />
                </Row>
              </form>

              <div style={s.actions}>
                <button onClick={handleSubmit} disabled={submitting}
                  style={{ ...s.btnBase, ...s.btnSave }} className="wf-btn">
                  {submitting ? (editing ? "UPDATING..." : "SAVING...") : (editing ? "UPDATE" : "SAVE")}
                </button>
                <button onClick={confirmPrint} disabled={printing}
                  style={{ ...s.btnBase, ...s.btnPrint }} className="wf-btn">
                  {printing ? "PRINTING..." : "PRINT"}
                </button>
                <button onClick={() => setUpdateOpen(true)}
                  style={{ ...s.btnBase, ...s.btnUpdate }} className="wf-btn">
                  UPDATE TABLE
                </button>
                {message && <div style={{ ...s.message, color: messageColor }}>{message}</div>}
              </div>
            </div>
          </div>

          {updateOpen && (
            <div style={s.backdrop} onClick={() => setUpdateOpen(false)}>
              <div style={s.modal} onClick={e => e.stopPropagation()}>
                <div style={s.modalTitle}>Mettre à jour une table d'options</div>
                <div style={s.modalBody}>
                  <button style={s.btnMenu} onClick={() => { setUpdateOpen(false); navigate("/options/fournisseurs"); }}>
                    Fournisseurs
                  </button>
                  <button style={s.btnMenu} onClick={() => { setUpdateOpen(false); navigate("/options/couleurs"); }}>
                    Couleurs
                  </button>
                </div>
                <div style={s.modalActions}>
                  <button style={s.btnCancel} onClick={() => setUpdateOpen(false)}>Fermer</button>
                </div>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

function Row({ s, label, children }) {
  return (
    <div style={s.row} className="wf-row">
      <div style={s.cellLabel} className="wf-label">{label}</div>
      <div style={s.cellInput}>{children}</div>
    </div>
  );
}
